import * as MyPage from '../../constants/User/MyPage'

const initialState = {
  
}
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case MyPage.GET_MY_CIRCLE_LIST_IN_MY_PAGE:
      return state;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/User/MyPage.js